import ChatScope from './ChatScope.vue'
import { createRouter, createWebHashHistory } from 'vue-router'
import maybeFixInvalidRoute from './maybe_fix_invalid_route'

export default function (store) {
  const routes = [
    { path: '/:chatScope', component: ChatScope },
    { path: '/:chatScope/:chat', component: ChatScope },
    { path: '/', component: { template: '' } }
  ]

  const router = createRouter({
    history: createWebHashHistory(),
    routes
  })

  // this callback also gets called on initial app load
  router.beforeEach(async (to, from, next) => {
    const nextRoute = await maybeFixInvalidRoute(to, store)
    next(nextRoute)
  })

  return router
}
